import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

const TOKEN = /\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*/g;
const LINK_CLASS = 'font-bold text-lagoon-600 underline decoration-lagoon-200 underline-offset-4 hover:decoration-lagoon-600';

/**
 * Renders the two inline marks our long-form content uses: `[label](href)` and `**bold**`.
 * Internal paths route in-app; `mailto:`/`tel:`/`https:` stay plain anchors. Nothing else is
 * interpreted, so content can never inject markup.
 */
export const RichText = ({ text }: { text: string }) => {
  const out: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(TOKEN)) {
    if (m.index! > last) out.push(text.slice(last, m.index));
    const [, label, href, bold] = m;
    if (bold) out.push(<strong key={m.index} className="font-extrabold text-ink">{bold}</strong>);
    else if (href!.startsWith('/')) out.push(<Link key={m.index} to={href!} className={LINK_CLASS}>{label}</Link>);
    else
      out.push(
        <a key={m.index} href={href} className={LINK_CLASS} {...(href!.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
          {label}
        </a>,
      );
    last = m.index! + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return <>{out.map((n, i) => <Fragment key={i}>{n}</Fragment>)}</>;
};
